// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.5 2C8.46244 2 6 4.46243 6 7.5C6 10.5376 8.46243 13 11.5 13C14.5376 13 17 10.5376 17 7.5C17 4.46243 14.5376 2 11.5 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.0001 12V19.1092L21.5082 16.6297L22.9143 18.0519L18.0001 22.9103L13.0859 18.0519L14.492 16.6297L17.0001 19.1092V12H19.0001Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.8762 14C12.0139 15.103 11.5 16.4915 11.5 18C11.5 19.5085 12.0139 20.897 12.8762 22H2V20C2 16.6863 4.68629 14 8 14H12.8762Z"}}]};

const UserArrowDownFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-arrow-down-filled',
    ref,
    icon: element,
  },
));

UserArrowDownFilledIcon.displayName = 'UserArrowDownFilledIcon';

export default UserArrowDownFilledIcon;
